import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { globalConfig } from "../../config/config";
import Box from '@mui/material/Box';
import { Button, TextField } from '@mui/material';

const ContentSearch = () => {


// constructor(props)
// {
// 	console.log(props);
//     super(props);
// }

// state = {
// 	ContentSearchObject: {},
//      ContentSearch: []
// };

// componentDidMount() 
// {
// 	this.handleOnLoad();
// }
// 
// handleOnLoad = () => {
//   axios.get(`<http://os-dev.origosoftware.com:3000/ContentSearch/`).then(res => {
//   const connectors = res.data;
//   console.log(connectors);
//   this.setState({ connectors });
//   console.log(res.data[0]);
// 	});
// 	
// }


 

return (	
	<>
		<div style={{display:"flex",justifyContent:"space-between"}}>
			<h4>Search any data</h4>
			
			<Link to="/breeze">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

		<div class="container-fluid">
        	<div class="container">
            	<div class="row">
					<div class="">

		    <Box sx={{ width: '1200px', maxWidth: '100%' }}>
    		  <TextField fullWidth label="What would you like me to get you?" id="prompt"
    		  	multiline
    		  	rows={3}
    			/>
    		</Box>

					</div>
				</div>
			</div>
		</div>

	</>
	
 );
 }
export default ContentSearch;


	// <form>
// 		<div class="container-fluid">
// 		<h4>Content Search</h4>
// 		<hr />
// 		<div class="row search-form-default">
// 			<div class="col-md-12">
// 				<form class="form-inline" >
// 							<input id="searchString" type="text" placeholder="Search..." value="" class="form-control input-xlarge col-sm-8"/>
// 							&nbsp;
// 							<button class="btn btn-success" value="Search" onclick="contentSearch()" >Search</button>
// 				</form>
// 			</div>
// 		</div>
// 
// 
// 
// 		<div class="search-classic">
// 			<h4><a href="#">Dr. Bentley Graham</a></h4>
// 			<a href="#{ombUserSession.getPlatformProperties().getProperty('ehx.context.url')}/EhxPocPage.jsf?username=#{ombUserSession.getUsername()}">http://www.patientcapturetools.com</a>
// 			<p>
// 				Dr. Graham specializes in diabetic care. He takes good care of all his patients.
// 			</p>
// 			<div id="searchResultsValue">
// 				inside value ...
// 			</div>
// 		</div>
//  				
// 		<div class="search-classic">
// 			<h4><a href="#">Dr. Grace Graham</a></h4>
// 			<a href="#{ombUserSession.getPlatformProperties().getProperty('ehx.context.url')}/EhxPocPage.jsf?username=#{ombUserSession.getUsername()}">http://www.patientcapturetools.com</a>
// 			<p>
// 				Dr. Graham specializes in pediatric care. She likes to have fun with all the children and gives them treats.										
// 			</p>
// 		</div>
// 				<div class="search-classic">
// 			<h4><a href="#">Dr. Tessa Dent</a></h4>
// 			<a href="#{ombUserSession.getPlatformProperties().getProperty('ehx.context.url')}/EhxPocPage.jsf?username=#{ombUserSession.getUsername()}">http://www.patientcapturetools.com</a>
// 			<p>
// 				Dr. Dent specializes in chiropractic care. She takes good care of all your back.
// 			</p>
// 		</div>
// 				<div class="search-classic">
// 			<h4><a href="#">Dr. Lester Paul Gibson</a></h4>
// 			<a href="#{ombUserSession.getPlatformProperties().getProperty('ehx.context.url')}/EhxPocPage.jsf?username=#{ombUserSession.getUsername()}">http://www.patientcapturetools.com</a>
// 			<p>
// 				Dr. Gibson specializes in guitar care. He takes good care of all his strings.
// 			</p>
// 		</div>
// 				<div class="search-classic">
// 			<h4><a href="#">Dr. Alice Chin</a></h4>
// 			<a href="#{ombUserSession.getPlatformProperties().getProperty('ehx.context.url')}/EhxPocPage.jsf?username=#{ombUserSession.getUsername()}">http://www.patientcapturetools.com</a>
// 			<p>
// 				Dr. Chin specializes in post surgical care. She takes good care of all her patients.
// 			</p>
// 		</div>
// 				<div class="search-classic">
// 			<h4><a href="#">Joseph Coulter</a></h4>
// 			<a href="#{ombUserSession.getPlatformProperties().getProperty('ehx.context.url')}/EhxPocPage.jsf?username=#{ombUserSession.getUsername()}">http://www.patientcapturetools.com</a>
// 			<p>
// 				Mr. Coulter specializes in cancer research. He takes good care of all his patients.
// 			</p>
// 		</div>  
// 	
// 		<hr />
// 		<div class="margin-top-20">
// 			<ul class="pagination">
// 				<li>
// 					<a href="#">Prev</a>
// 				</li>
// 				<li>
// 					<a href="#">1</a>
// 				</li>
// 				<li>
// 					<a href="#">2</a>
// 				</li>
// 				<li class="active">
// 					<a href="#">3</a>
// 				</li>
// 				<li>
// 					<a href="#">4</a>
// 				</li>
// 				<li>
// 					<a href="#">5</a>
// 				</li>
// 				<li>
// 					<a href="#">Next</a>
// 				</li>
// 			</ul>
// 		</div>
// 
// 	</div>
//  	</form>

//  }
//  
//  var searchResultsVar='';
// var xhr = new XMLHttpRequest();
// 
// xhr.addEventListener("progress", updateProgress);
// xhr.addEventListener("load", transferComplete);
// xhr.addEventListener("error", transferFailed);
// xhr.addEventListener("abort", transferCancelled);
// 
// function updateProgress(evt)
// {	
// 	alert('progress -> ' + evt);
// }
// function transferComplete(evt)
// {	
// 	alert('load -> ' +evt);
// }
// function transferFailed(evt)
// {	
// 	alert('error -> ' + JSON.stringify(evt));
// }
// function transferCancelled(evt)
// {	
// 	alert('abort -> ' +evt);
// }
// xhr.onreadystatechange = function() {
//     if (xhr.readyState === 4) 
//     {
//     		//alert('1. Response => ' + xhr.readyState + ' status => ' + xhr.status);
//         console.log(readBody(xhr));
//     }
// } 
// xhr.onprogress = function () {
// 	//alert('loading - ' + xhr.status);
// 	  console.log('LOADING: ', xhr.status);
// 	};
// 
// xhr.onload = function () {
// 	//alert('done - ' + xhr.status);
// 	  console.log('DONE: ', xhr.status);
// 	  //alert(xhr.response);
// 	  // load the search results object
// 	  document.getElementById("searchResultsValue").innerHTML = xhr.response;
// 	};
//  function readBody(xhr) 
//  {
// 	    var data;
// 	    //alert('1. ResponseType => ' + xhr.responseType);
// 	    if (!xhr.responseType || xhr.responseType === "text") 
// 	    {
// 	        data = xhr.responseText;
// 	    }
// 	    else if (xhr.responseType === "document") 
// 	    {
// 	        data = xhr.responseXML;
// 	    } 
// 	    else 
// 	    {
// 	        data = xhr.response;
// 	    }
// 	    //alert('1. Data => '  + data);
// 	    return data;
// 	}
// 
// function	contentSearch()
// {
// 	//alert('search');
// 	 var obj = document.getElementById("ContentSearchForm:searchString");
// 	 var searchString = obj.value;
// 	 //alert("3 searching for " + searchString);
//  	//alert("searching for content - search query = " + searchString);
//  	
//  	var searchUrl = "http://breeze.gazelleplatform.com:6060/gazelle-breeze/rest-ws/content-search-service/searchContent?searchString=" + searchString;
//  	//var searchUrl = "http://localhost:3000/content/search/" + searchString;
//  	//alert(searchUrl);
//  	xhr.open("GET", searchUrl, false);
//  	xhr.send();
//  	
// }              